import { useMemo } from 'react';
import { formatEnglishDate } from '../../../lib/dateFormat';
import './SubmissionSlider.css';

export interface SubmissionSliderItem {
  id: string;
  name: string;
  date: string;
}

interface SubmissionSliderProps {
  submissions: SubmissionSliderItem[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

const SubmissionSlider = ({ submissions, selectedId, onSelect }: SubmissionSliderProps) => {
  const selectedIndex = useMemo(() => {
    if (!selectedId) return submissions.length - 1;
    return submissions.findIndex((s) => s.id === selectedId);
  }, [submissions, selectedId]);

  const formatDate = (dateStr: string) => {
    return formatEnglishDate(dateStr, { month: 'short', day: 'numeric' });
  };

  if (submissions.length === 0) {
    return null;
  }

  return (
    <div className="submission-slider">
      <div className="submission-slider__header">
        <span className="submission-slider__label">Select Submission</span>
        {submissions.length > 1 && (
          <span className="submission-slider__hint">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Click to compare
          </span>
        )}
      </div>
      <div className="submission-slider__track">
        {submissions.map((submission, index) => {
          const isActive = index === selectedIndex;
          const isVisited = index < selectedIndex;
          
          return (
            <div key={submission.id} className="submission-slider__segment">
              {index > 0 && (
                <div className="submission-slider__line">
                  <div
                    className="submission-slider__line-fill"
                    style={{ width: index <= selectedIndex ? '100%' : '0%' }}
                  />
                </div>
              )}
              <button
                type="button"
                className={`submission-slider__node ${isActive ? 'submission-slider__node--active' : ''} ${isVisited ? 'submission-slider__node--visited' : ''}`}
                onClick={() => onSelect(submission.id)}
                title={`${submission.name} - ${formatDate(submission.date)}`}
              >
                {index + 1}
                <span className="submission-slider__node-label">
                  {formatDate(submission.date)}
                </span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export { SubmissionSlider };
